/**
 * Sprint v1.28.2 — CTA display name for voter-facing "Ask ___ a Question"
 * buttons (and similar callsites).
 *
 * Rule:
 *   1. If admin set an explicit short_name on the persona, use it verbatim.
 *      Lets operators control copy for tricky names (acronyms like "NDDC",
 *      honorifics like "President Tinubu", etc.).
 *   2. Otherwise, fall back to the word-split heuristic that shipped
 *      before — second word if present, else first word. Good enough for
 *      most official names ("Governor Sanwo-Olu" → "Sanwo-Olu").
 *
 * Keeping this in a pure function so:
 *   • Every callsite (ProfilePage CTA, potential future places) uses the
 *     same resolution order — no drift.
 *   • Unit tests can exercise both branches without mounting React.
 *
 * Accepts either camelCase (from @qm/types) or snake_case (raw from
 * the API — the web-side mapping in useAppState normalises but a stray
 * direct consumer might still pass snake_case).
 */
export function personaCtaName(persona) {
  if (!persona) return "";
  const explicit =
    typeof persona.shortName === "string" ? persona.shortName
    : typeof persona.short_name === "string" ? persona.short_name
    : null;
  if (explicit && explicit.trim()) return explicit.trim();
  // Fallback heuristic — kept identical to the pre-v1.28.2 inline code so
  // existing rows without short_name render the same way they did before.
  const name = persona.name ?? "";
  const parts = name.split(" ").filter(Boolean);
  return parts[1] || parts[0] || "";
}
